import * as v from 'valibot';
import { baseArticleScheme } from './singlePostSchema';

const visibilitySchema = v.object({
  show: v.array(v.object({ type: v.string(), value: v.string() })),
  hide: v.array(v.object({ type: v.string(), value: v.string() })),
});

const baseSchema = v.object({
  id: v.number(),
  postProcessed: v.boolean(),
  attributesRemoved: v.boolean(),
  renamed: v.boolean(),
});

const sidebarItem = v.variant('type', [
  v.object({
    ...baseSchema.entries,
    type: v.literal('bh-kiss__html'),
    attributes: v.object({
      title: v.optional(v.string()),
      deviceType: v.array(v.string()),
      visibility: v.optional(visibilitySchema),
      text: v.string(),
    }),
    children: v.array(v.unknown(), 'Error on content children'),
  }),
  v.object({
    ...baseSchema.entries,
    type: v.literal('bh-kiss__posts-collection'),
    attributes: v.object({
      posts: v.array(baseArticleScheme),
    }),
    children: v.array(v.unknown(), 'Error on content children'),
  }),
  v.object({
    ...baseSchema.entries,
    type: v.literal('bh-kiss__taxonomy-posts'),
    attributes: v.object({
      type: v.string(),
      value: v.number(),
      quantity: v.number(),
      title: v.string(),
      posts: v.array(baseArticleScheme),
    }),
    children: v.array(v.unknown(), 'Error on content children'),
  }),
  v.object({
    ...baseSchema.entries,
    type: v.literal('burninghut__quickpolls'),
    attributes: v.object({
      title: v.string(),
      ids: v.array(v.number()),
    }),
    children: v.array(v.unknown(), 'Error on content children'),
  }),
  v.object({
    ...baseSchema.entries,
    type: v.literal('bh-kiss__top-posts'),
    attributes: v.object({
      quantity: v.number(),
      title: v.string(),
      posts: v.array(baseArticleScheme),
    }),
    children: v.array(v.unknown(), 'Error on content children'),
  }),
  v.object({
    ...baseSchema.entries,
    type: v.literal('bh-kiss__talker-comment-widget'),
    attributes: v.object({
      // Comments schemas
      last: v.array(v.any()),
      top: v.nullable(v.any()),
    }),
    children: v.array(v.unknown(), 'Error on content children'),
  }),
  v.object({
    ...baseSchema.entries,
    type: v.literal('burninghut__greybox'),
    children: v.array(v.unknown(), 'Error on content children'),
    attributes: v.unknown(), // TODO: add if needed
  }),
]);

export const sidebarSchema = v.object({
  'above-menu': v.array(sidebarItem),
  'below-menu': v.array(sidebarItem),
  home: v.array(sidebarItem),
  sidebar: v.array(sidebarItem),
  'after-first-paragraph': v.array(sidebarItem),
  'post-dynamic': v.array(sidebarItem),
  'above-comments': v.array(sidebarItem),
  'below-comments': v.array(sidebarItem),
  scripts: v.array(sidebarItem),
});
